module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value1 || _vm.value2) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-first",
    style: ({
      width: _vm.getPercentage1
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-bar progress-bar-second",
    style: ({
      width: _vm.getPercentage2
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "grow"
  }, [_vm._v("\n            " + _vm._s(_vm.description1) + ": " + _vm._s(this.value1) + " (" + _vm._s(_vm.getPercentage1) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "grow text-right"
  }, [_vm._v("\n            " + _vm._s(_vm.description2) + ": " + _vm._s(this.value2) + " (" + _vm._s(_vm.getPercentage2) + ")\n        ")])])]) : _c('div', {
    staticClass: "text-gray"
  }, [_vm._v("No data available.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d38f32f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChartProgress.vue
// module id = 552
// module chunks = 1